var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQqIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 27,
    width: 8,
    height: 2,
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27,
    width: 8,
    height: 2,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 10,
    height: 2,
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 10,
    height: 2,
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 26,
    width: 6,
    height: 2,
    fill: "#f2a31a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 26,
    width: 6,
    height: 2,
    fill: "#f2a31a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 9,
    height: 1,
    fill: "#f2a31a"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 9,
    height: 1,
    fill: "#f2a31a"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 4,
    height: 9,
    fill: "#000000"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 4,
    height: 9,
    fill: "#000000"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 3,
    height: 5,
    fill: "#000000"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 3,
    height: 5,
    fill: "#000000"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 14,
    height: 2,
    fill: "#000000"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 18,
    height: 4,
    fill: "#000000"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 20,
    height: 7,
    fill: "#000000"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 16,
    height: 2,
    fill: "#000000"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 10,
    height: 3,
    fill: "#ffffff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 14,
    height: 6,
    fill: "#ffffff"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 10,
    height: 2,
    fill: "#ffffff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 12,
    height: 2,
    fill: "#000000"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 18,
    height: 3,
    fill: "#000000"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 20,
    height: 6,
    fill: "#000000"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 18,
    height: 2,
    fill: "#000000"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 5,
    height: 5,
    fill: "#ffffff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 5,
    height: 5,
    fill: "#ffffff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 2,
    height: 2,
    fill: "#000000"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 2,
    height: 2,
    fill: "#000000"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 8,
    height: 1,
    fill: "#000000"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 12,
    height: 2,
    fill: "#f2a31a"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 8,
    height: 1,
    fill: "#f2a31a"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 20,
    height: 2,
    fill: "#000000"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 22,
    height: 3,
    fill: "#bd1018"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 16,
    height: 2,
    fill: "#d91d25"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 4,
    height: 7,
    fill: "#000000"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 4,
    height: 6,
    fill: "#d91d25"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 3,
    height: 2,
    fill: "#bd1018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQqIcon);
export default __webpack_public_path__ + "static/media/qqIcon.9ca1694cce4578fcf7bbe7a768a3cb64.svg";
export { ForwardRef as ReactComponent };